export const RESET = 'MODULE_UPDATE_RESET'
export const SET_ERROR = 'MODULE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'MODULE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'MODULE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'MODULE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'MODULE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'MODULE_UPDATE_UPDATE_RETRIEVED'



// WEBPACK FOOTER //
// ./src/store/modules/module/update/mutation_types.js